import type { IconSvgObject } from './types';

const DressingTable01Icon: IconSvgObject = [
  ["path", { d: "M10 6L11 5M11 8L13 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 14V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V14", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 14V22M19 14V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 14H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M5 19L19 19", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M11.5 16.5H12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default DressingTable01Icon;
